import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import router from './router'
import App from './App.vue'
import './assets/css/main.scss'
import './assets/css/markdown-body.scss'
import { resolveTenant } from './api/tenant'
import { fetchCurrentSchool } from './api/school'
import { Storage } from './utils/storage'

const app = createApp(App)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(router)
app.use(ElementPlus)

const bootstrap = async () => {
	const cachedTenantId = Storage.getTenantId()
	let matchedTenantId = ''
	try {
		// 为了防止 /tenant/resolve 请求被之前的错误 426 拦截影响，加 X-Skip-Tenant 头确保纯净解析
		const res: any = await resolveTenant(window.location.host)
		if (res?.code === 0) {
			matchedTenantId = String(res?.data?.tenantId || '')
		}
		if (matchedTenantId) {
			Storage.setTenantId(matchedTenantId)
		}
	} catch {
	}
	if (!matchedTenantId && cachedTenantId) {
		matchedTenantId = cachedTenantId
	}

	// 统一由 router.beforeEach 拦截，确保在初始化并挂载 App 之后正确渲染
	if (matchedTenantId) {
		try {
			const res: any = await fetchCurrentSchool()
			if (res?.code === 0 && res.data?.id) {
				Storage.setSchoolId(String(res.data.id))
			}
		} catch {
		}
	}

	app.mount('#app')
}

bootstrap()
